var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert-container"},[_c('div',{staticClass:"alert-icon"},[_c('i',{staticClass:"fas fa-exclamation-triangle"})]),_c('div',{staticClass:"alert-content"},[_c('p',{staticClass:"alert-message"},[_vm._v(" Please click "),_c('strong',[_vm._v("Add")]),_vm._v(" to save the dependent information before continuing. ")])])])
}]

export { render, staticRenderFns }